import React from "react";
import Navbar from "./navbar/Navbar";
import Footer from './footer/Footer';
import "./body.css";
import '../scroll/Scroll.css';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Acceuil extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            accueil: [],
            load: false
        }
        document.addEventListener('DOMContentLoaded', function () {
            window.onscroll = function (ev) {
                document.getElementById("cRetour").className = (window.pageYOffset > 100) ? "cVisible" : "cInvisible";
            };
        });
    }

    componentDidMount = () => {
        fetch(SERVER_ADDRESS + '/accueil')
            .then(res => res.json())
            .then(res => this.setState({ accueil: res }, () => this.setState({ load: true })))
    }

    render() {
        return (
            (this.state.load &&
                <div id="haut">
                    <Navbar />
                    <div className="block-img-acceuil-top">


                        <div
                            style={{
                                backgroundImage: `url(${SERVER_ADDRESS}/images/${this.state.accueil[0].liens})`
                            }}
                            className="img-acceuil">
                        </div>

                        <div className="uneclassspecial">
                            <div className="block-tilte-des">
                                <h1 className="size-tilte">{this.state.accueil[0].titre}</h1>
                                <h2 className="description-accueil">{this.state.accueil[0].text}</h2>
                            </div>
                        </div>



                        <div id="chevron-bas">
                            <p id="scroll_down" className="scroll_down"></p>
                            <a href="#bas" className="chevron-a"><img id="chevron" className="chevron" src="https://media1.giphy.com/media/Wtg8Bmgul1Qxc0otod/giphy.gif?cid=790b761141299a6f383b79d52b352dbfe1cb0fcbe1eaf2b4rid=giphy.gif" alt="chevron" /></a>
                        </div>




                    </div>

                    <div id="bas" className="block-txt-img-mid">

                        <div className="margintop"></div>
                        {/* 1 ere partie accueil  */}
                        <div className="block-one-accueil">
                            <div
                                style={{
                                    backgroundImage: `url(${SERVER_ADDRESS}/images/${this.state.accueil[1].liens})`
                                }}
                                className="img-mid">

                            </div>


                            <div className="txt-mid">

                                <h3 className="center-mid-h2">{this.state.accueil[1].titre}</h3>

                                <p className="center-mid-p">{this.state.accueil[1].text}</p>

                            </div>

                        </div>


                        {/* 1 ere partie accueil  */}


                        {/* 2 eme partie accueil  */}

                        <div className="block-one-accueil">

                            <div
                                style={{
                                    backgroundImage: `url(${SERVER_ADDRESS}/images/${this.state.accueil[2].liens})`
                                }}
                                className="img-mid img-mid-two">


                            </div>

                            <div className="txt-mid">

                                <h3 className="center-mid-h2">{this.state.accueil[2].titre}</h3>

                                <p className="center-mid-p">{this.state.accueil[2].text}</p>

                            </div>

                        </div>


                        {/* 2 eme partie accueil  */}


                        {/* 3 eme partie accueil  */}

                        <div className="block-one-accueil">

                            <div
                                style={{
                                    backgroundImage: `url(${SERVER_ADDRESS}/images/${this.state.accueil[3].liens})`
                                }}
                                className="img-mid">


                            </div>

                            <div className="txt-mid">

                                <h3 className="center-mid-h2">{this.state.accueil[3].titre}</h3>

                                <p className="center-mid-p">{this.state.accueil[3].text}</p>

                            </div>

                        </div>


                        {/* 3 eme partie accueil  */}


                        {/* 4 eme partie accueil  */}

                        <div className="block-one-accueil">

                            <div
                                style={{
                                    backgroundImage: `url(${SERVER_ADDRESS}/images/${this.state.accueil[4].liens})`
                                }}
                                className="img-mid img-mid-two">


                            </div>

                            <div className="txt-mid">

                                <h3 className="center-mid-h2">{this.state.accueil[4].titre}</h3>

                                <p className="center-mid-p">{this.state.accueil[4].text}</p>

                            </div>

                        </div>


                        {/* 4 eme partie accueil  */}
                    </div>
                    <div><a id="cRetour" className="cInvisible" href="#haut"> </a></div>
                    <Footer />
                </div>
            )
        );
    }
}

export default Acceuil;
